import React, { useState } from 'react';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { isRenderingOnServer } from '../../helpers/projectConstant';

type KeywordsProps = {
  keywords: string[];
}

const Keywords = ({ keywords }: KeywordsProps) => {
  const [tags, setTags] = useState(keywords.slice(0, 5));
  return (
    <div className="flex flex-wrap gap-3">
      {tags?.map((item, index) => (
        <div
          className="bg-sand-100 px-[10px] py-1 rounded-[24px] font-roboto font-medium text-[10px] leading-[15px]"
          key={index}
        >
          {item}
        </div>
      ))}
      {keywords.length !== tags.length && (
        <button type="button" onClick={() => setTags(() => keywords)}>
          <FontAwesomeIcon icon={faEllipsis as IconProp} className="text-blue-500 hover:text-blue-700" />
        </button>
      )}
    </div>
  );
};

type SearchResultProps = {
  key?: React.Key;
  sourceUrl: string;
  keywords: string[];
  description: string;
  id: string;
  title: string;
  slug: string;
}

const SearchResult = ({ title, slug, description, keywords, sourceUrl }: SearchResultProps) => {
  const extractDomain = (url: string): string => {
    if (!isRenderingOnServer()) {
      return new URL(url).hostname;
    }
    const urlLabels = url.split('/');
    if (urlLabels.length >= 3) {
      return urlLabels[2];
    }
    return '';
  };

  const extractDomainFromUrl = (url: string): string => extractDomain(url);

  return (
    <div className="w-full border border-solid border-stone-200 rounded-lg p-5 mb-5">
      <h2>
        <a href={`/kennisbank/home/artikel/${slug}`} className="no-underline block font-roboto text-blue-500 hover:text-black font-bold text-xl mb-5">
          {title}
        </a>
      </h2>
      <p>{description}</p>
      <div className="font-body text-stone-600 font-bold text-2 mt-5 mb-3">
        Trefwoorden:
      </div>
      <Keywords keywords={keywords} />
      <div className="text-stone-600 font-bold text-2 mt-5 mb-2 font-body">
        Bron: <a
          href={sourceUrl}
          target="_blank"
          rel="noreferrer"
          className="text-blue-500 underline font-medium"
        >
          {extractDomainFromUrl(sourceUrl)}
        </a>
      </div>
    </div>
  );
};

export default SearchResult;